module.exports = __webpack_public_path__ + "static/media/dribbble.1bfec3f6.png";